import type { OrderDetailResponseDto } from "Infrastructure/Api/Api";
import { UserPermissions } from "Infrastructure/Api/permissions";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { hasPermission } from "Infrastructure/Utilities/Permissions/hasPermission";
import { feesAtom } from "Order/Atom/paymentAtom";
import { EditFeeForm } from "Order/Modules/Payment/Components/Forms/EditFeeForm";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { Typography } from "@mui/material";
import { useAtom } from "jotai";

type FeeFormWidgetProps = {
	order: OrderDetailResponseDto;
};

const paymentResource = Resources.base.payment.shared;

export function FeeFormWidget({ order }: FeeFormWidgetProps) {
	const { t } = useResource();
	const [fees] = useAtom(feesAtom);

	const hasReadFeePermission = hasPermission(
		UserPermissions.OrderFeeModule.read,
	);

	if (!hasReadFeePermission) {
		return null;
	}

	return (
		<BaseCard>
			<Typography variant="h5">{t(paymentResource.fees)}</Typography>
			{fees ? (
				<EditFeeForm
					fees={fees}
					orderId={order.id}
					isDisabled={order.sfInvoicePeriod !== null}
				/>
			) : (
				<></>
			)}
		</BaseCard>
	);
}
